import { Component, OnInit, Inject, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { forkJoin } from 'rxjs';
import { ModuleStockingService } from 'src/app/services/module-stocking/module-stocking.service';
import { LookupService } from 'src/app/services/lookup/lookup.service';
import { logData } from 'src/app/shared/logger';

@Component({
  selector: 'app-module-type2-edit-dialog',
  templateUrl: './module-type2-edit-dialog.component.html',
  styleUrls: ['./module-type2-edit-dialog.component.scss']
})
export class ModuleType2EditDialogComponent implements OnInit {
  moduleTypeChanged = new EventEmitter();
  addMasterEventEmitter = new EventEmitter();
  editMasterEventEmitter = new EventEmitter();

  parentData: any;
  submitted = false;
  editMode = false;
  noteditMode = false;
  isLine = false;
  isLinePath = false;
  searchedValue = '';

  newDockList: any[] = [];
  moduleTypeToDockForpopup: any[] = [];
  filteredUnloadAreaList: any[] = [];
  filteredModuleTypeList: any[] = [];
  filteredIdLineList: any[] = [];
  filteredModelNameList: any[] = [];
  filteredLinePathList: any[] = [];
  filteredLineList: any[] = [];
  filteredTrackingPointList: any[] = [];

  addOrEditform: UntypedFormGroup = this.formBuilder.group({
    unload_area: ['', Validators.required],
    module_type: ['', Validators.required],
    module_desc: ['', Validators.required],
    line: [[], Validators.required],
    id_line: [[], Validators.required],
    linePathList: [[], Validators.required],
    model_name: [[], Validators.required],
    tracking_point: ['', Validators.required],
    dock: [[], Validators.required],
    type_of_module: ['controlling', Validators.required],
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private readonly dialogeRef: MatDialogRef<ModuleType2EditDialogComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly cdr: ChangeDetectorRef,
    private readonly moduleStockingService: ModuleStockingService,
    private readonly lookupService: LookupService
  ) {
    this.parentData = data;
  }

  get addOrEdit() {
    return this.addOrEditform.controls;
  }

  ngOnInit(): void {


    /*
        

        


        logData(`distinctUA: ${JSON.stringify(distinctUA)}`);
        logData(`distinctModuleType: ${JSON.stringify(distinctModuleType)}`);
        this.uAListForpopup.push(distinctUA);
        this.moduleTypeListForpopup.push(distinctModuleType);

        */

    logData(`parentData: ${JSON.stringify(this.parentData)}`);

    this.filteredUnloadAreaList = [
      ...new Set(
        this.parentData.mtDDLList
          .map((item: any) => item.unload_area)
      )
    ].map(unload_area => ({ unload_area }));


    this.filteredTrackingPointList = [
      ...new Set(
        this.parentData.mtDDLList
          .map((item: any) => item.tracking_point)
      )
    ].map(tracking_point => ({ tracking_point }));


    
    
    this.filteredLineList = [
      ...new Set(
        this.parentData.idLineDDLList
          .map((item: any) => item.line)
      )
    ].map(line => ({ line }));

    this.filteredIdLineList = [
      ...new Set(
        this.parentData.idLineDDLList
          .map((item: any) => item.id_line)
      )
    ].map(id_line => ({ id_line }));

    this.filteredLinePathList = [
      ...new Set(
        this.parentData.idLineDDLList
          .map((item: any) => item.osp_line_path)
      )
    ].map(osp_line_path => ({ osp_line_path }));

    this.filteredModelNameList = [
      ...new Set(
        this.parentData.modelNameList
          .map((item: any) => item.model_name)
      )
    ].map(model_name => ({ model_name }));




    if (this.parentData.mode === 'add') {
      this.noteditMode = true;
      this.editMode = false;
      return;
    }

    this.noteditMode = false;
    this.editMode = true;

    const row = this.data?.data;
    this.newDockList = this.toSelection(row?.dock, 'dock');

    this.addOrEditform.patchValue({
      unload_area: { unload_area: row?.unload_area },
      module_type: row?.module_type,
      module_desc: { module_desc: row?.module_description, module_type: row?.module_type },
      line: this.toSelection(row?.line, 'line'),
      id_line: this.toSelection(row?.id_line, 'id_line'),
      linePathList: this.toSelection(row?.osp_line_path, 'osp_line_path'),
      model_name: this.toSelection(row?.model_name, 'model_name'),
      tracking_point: { tracking_point: row?.tracking_point },
      dock: this.toSelection(row?.dock, 'dock'),
      type_of_module: row?.is_controlling_module ? 'controlling' : 'independent',
    });
    this.refreshLinePathOptions();

    /* this.addOrEditform.get('unload_area')?.disable();
     this.addOrEditform.get('module_type')?.disable();
     this.addOrEditform.get('dock')?.disable();
     this.addOrEditform.get('line')?.disable();
     this.addOrEditform.get('linePathList')?.disable();
     */
  }

  unloadAreaChange() {
    const unloadArea = this.addOrEditform.get('unload_area')?.value?.unload_area;

    const distinctModuleType = Array.from(
      new Map(
        this.parentData.mtDDLList
          .filter((item: any) => item.unload_area === unloadArea)
          .map((item: any) => [
            `${item.module_type}${item.module_desc}`,
            {
              module_type: item.module_type,
              module_desc: item.module_desc
            }
          ])
      ).values()
    );

    this.addOrEditform.patchValue({
      module_type: '',
      module_desc: '',
      line: [],
      id_line: [],
      linePathList: [],
      dock: [],
    });
    this.refreshLinePathOptions();

    this.newDockList = [];


    this.filteredModuleTypeList = [
      ...new Set(
        this.parentData.mtDDLList
          .filter((item: any) => item.unload_area === unloadArea)
          .map((item: any) => item.module_type)
      )
    ].map(module_type => ({ module_type }));



    // const source = this.parentData.moduleDescList ?? [];
    // this.filteredModuleTypeList = this.checkNull(unloadArea)
    //   ? [...source]
    //   : source.filter((item : any) => !item.unload_area || item.unload_area === unloadArea);
  }

  moduleTypeChange() {
    const unloadArea = this.addOrEditform.get('unload_area')?.value?.unload_area;
    const moduleType = this.addOrEditform.get('module_type')?.value?.module_type;

    const moduleDesc = this.parentData.mtDDLList.find(
      (item: any) =>
        item.unload_area === unloadArea &&
        item.module_type === moduleType
    )?.module_desc;

    this.addOrEditform.patchValue({ module_desc: moduleDesc });
    // this.addOrEditform.patchValue({ module_type: moduleType });

    if (this.checkNull(moduleType)) {
      this.newDockList = [];
      return;
    }

    this.loadDockDetails(moduleType);
  }

  private readonly lineLinks = [
    { control: 'line', key: 'line' },
    { control: 'id_line', key: 'id_line' },
    { control: 'linePathList', key: 'osp_line_path' },
  ];

  onLineGroupChange(control: string) {
    const source = this.lineLinks.find((link) => link.control === control);
    if (!source) {
      return;
    }
    const selected = new Set(this.pluck(this.addOrEditform.get(control)?.value, source.key));
    const rows = (this.parentData.idLineDDLList ?? []).filter((item: any) => selected.has(item[source.key]));

    const patch: Record<string, any[]> = {};
    this.lineLinks
      .filter((link) => link.control !== control)
      .forEach((link) => {
        patch[link.control] = link.control === 'linePathList'
          ? this.pickLinePaths(rows)
          : this.toSelection([...new Set(rows.map((item: any) => item[link.key]))], link.key);
      });
    this.addOrEditform.patchValue(patch);
    this.refreshLinePathOptions();

    this.isLine = this.submitted && this.checkNull(this.addOrEdit.line.value);
    this.isLinePath = this.submitted && this.checkNull(this.addOrEdit.linePathList.value);
  }

  private comboKey(item: any): string {
    return `${item.id_line}|${item.line}`;
  }

  // Only one osp_line_path is allowed per id_line + line combination.
  // Auto-selects the first osp_line_path when id_line or line is selected.
  private pickLinePaths(rows: any[]): any[] {
    const current = new Set(this.pluck(this.addOrEdit.linePathList.value, 'osp_line_path'));
    const pathsByCombo = new Map<string, any[]>();
    rows.forEach((item: any) => {
      const paths = pathsByCombo.get(this.comboKey(item)) ?? [];
      if (!paths.includes(item.osp_line_path)) {
        paths.push(item.osp_line_path);
      }
      pathsByCombo.set(this.comboKey(item), paths);
    });

    const picked = [...pathsByCombo.values()].map(
      (paths) => paths.find((path) => current.has(path)) ?? paths[0]
    );
    return this.toSelection([...new Set(picked)], 'osp_line_path');
  }

  private refreshLinePathOptions() {
    const rows = this.parentData.idLineDDLList ?? [];
    const selected = new Set(this.pluck(this.addOrEdit.linePathList.value, 'osp_line_path'));
    const takenCombos = new Set(
      rows.filter((item: any) => selected.has(item.osp_line_path)).map((item: any) => this.comboKey(item))
    );
    const disabled = new Set(
      rows
        .filter((item: any) => takenCombos.has(this.comboKey(item)) && !selected.has(item.osp_line_path))
        .map((item: any) => item.osp_line_path)
    );

    this.filteredLinePathList = this.filteredLinePathList.map((option) => ({
      osp_line_path: option.osp_line_path,
      disabled: disabled.has(option.osp_line_path),
    }));
  }

  // Derives line / line path / available docks for the resolved module type.
  private loadDockDetails(moduleType: string) {
    let dockInfo = [];
    let dockList = [];

    const lookupSubscriptions = [
      this.moduleStockingService.getDockByModuleType(moduleType)
    ];

    forkJoin(lookupSubscriptions).subscribe({
      next: (res) => {
        dockInfo = res[0]['body'];

        if (dockInfo.length > 0) {

          this.newDockList = [
            ...new Set(
              dockInfo
                .map((item: any) => item.dock)
            )
          ].map(dock => ({ dock }));

        } else {
          dockList = [];
          this.newDockList = [];
          this.addOrEditform.patchValue({ dock: [] });
        }

        /*
        const count = parseInt(res[0]['body'][0].count);
        this.moduleTypeToDockForpopup = count > 0 ? [{ value: 'No' }] : [{ value: 'Yes' }, { value: 'No' }];

        if (res[0]['body'] !== 'No Content' && res[0]['body'] !== '') {
          const docksToRemove = res[0]['body'].map((item) => item.dock);
          this.newDockList = dockList.filter((dock) => !docksToRemove.includes(dock.dock));
        } else {
          this.newDockList = dockList;
        }

        if (!this.checkNull(this.newDockList) && this.newDockList.length === 1) {
          this.addOrEditform.patchValue({ dock: this.newDockList[0] });
        }

        this.cdr.detectChanges();
        */
      },
    });
  }

  callRespectiveFunction() {
    if (this.data?.mode === 'edit') {
      this.editModuletype();
    } else {
      this.addMasterDetails();
    }
  }

  addMasterDetails() {
    const raw = this.addOrEditform.getRawValue();

    this.isLine = this.checkNull(raw.line);
    this.isLinePath = this.checkNull(raw.linePathList);

    if (this.isLine || this.isLinePath || this.addOrEditform.invalid) {
      this.submitted = true;
      return;
    }

    this.addMasterEventEmitter.emit(this.buildPayload(raw));
    this.dialogeRef.close();
  }

  editModuletype() {
    if (this.addOrEditform.invalid) {
      this.submitted = true;
      return;
    }

    this.editMasterEventEmitter.emit(this.buildPayload(this.addOrEditform.getRawValue()));
    this.dialogeRef.close();
  }

  private buildPayload(raw: any) {
    return {
      unload_area: raw.unload_area?.unload_area ?? raw.unload_area,
      module_type: raw.module_type?.module_type ?? raw.module_type,
      module_desc: (raw.module_desc?.module_desc ?? raw.module_desc ?? '').trim(),
      line: this.pluck(raw.line, 'line'),
      id_line: this.pluck(raw.id_line, 'id_line'),
      line_path: this.pluck(raw.linePathList, 'osp_line_path'),
      model_name: this.pluck(raw.model_name, 'model_name'),
      tracking_point: raw.tracking_point?.tracking_point ?? raw.tracking_point,
      dock: this.pluck(raw.dock, 'dock'),
      is_controlling_module: raw.type_of_module === 'controlling',
    };
  }

  private toSelection(value: any, key: string): any[] {
    const values = Array.isArray(value) ? value : [value];
    return values.filter((v) => !this.checkNull(v)).map((v) => ({ [key]: v }));
  }

  private pluck(selection: any[], key: string): any[] {
    return (selection ?? []).map((item) => item?.[key] ?? item);
  }


  /*
  onFilter(event: any) {
    const query = event.filter;
    this.searchedValue = query;
    const source = this.parentData.lineList ?? [];

    if (query?.length === 1) {
      const isExisting = source.some((line) => line.line.toLowerCase() === query.toLowerCase());

      this.filteredLineList = isExisting
        ? source.filter((line) => line.line.toLowerCase().includes(query.toLowerCase()))
        : [...source, { line: query, isNew: true, newItemClass: 'new-item' }];
    } else {
      this.filteredLineList = source.filter((line) => line.line.length === 1);
    }
  }

  */

  onFilterTrackingPoint(event: any) {
    const query = event.filter;
    this.searchedValue = query;
    const source = this.parentData.trackingPointList ?? [];

    if (!this.checkNull(query) && query.length === 2) {
      const isExisting = source.some(
        (tp) => tp.tracking_point.toLowerCase() === query.toLowerCase()
      );

      this.filteredTrackingPointList = isExisting
        ? source.filter((tp) => tp.tracking_point.toLowerCase().includes(query.toLowerCase()))
        : [...source, { tracking_point: query.toUpperCase(), isNew: true, newItemClass: 'new-item' }];
    } else if (!this.checkNull(query) && query.length === 1) {
      this.filteredTrackingPointList = source.filter((tp) =>
        tp.tracking_point.toLowerCase().startsWith(query.toLowerCase())
      );
    } else {
      this.filteredTrackingPointList = source.filter((tp) => tp.tracking_point.length === 2);
    }
  }

  checkNull(value: any): boolean {
    try {
      if (Object.prototype.toString.call(value) === '[object Array]') {
        return value.length === 0;
      }
      if (Object.prototype.toString.call(value) === '[object Object]') {
        return false;
      }
      return (
        value === null ||
        value === undefined ||
        value.trim() === '' ||
        value === 'undefined' ||
        value === 'null'
      );
    } catch (error) {
      return false;
    }
  }
}